import styled from 'styled-components/macro';

export const LinkListItemWrapper = styled.div`
  margin: 0 0 1.583rem 0;
  display: flex;
  flex-direction: column;
  perspective: 900px;
`;
